import { TemplateRef } from '@angular/core';

export interface ReportTemplate {
  report: string;
  template: TemplateRef<any>;
  email?: string;
  suffix?: string;
  sellingCompany?: string;
  ccEmail?: string;
  emailSubject?: string;
  emailBody?: string;
  emailContacts?: any[];
  attachDocuments?: boolean;
  type?: string;
}
